
import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
} from "react";

import "./Staff_Report_Dashbord.css";

import slider1 from "../assets/teacher1.jpg";
import slider2 from "../assets/Teacher2.jpg";
import slider3 from "../assets/Teacher3.jpg";
import slider4 from "../assets/Teacher4.jpg";

import {
  FaSchool,
  FaUsers,
  FaChalkboardTeacher,
  FaHome,
  FaChevronLeft,
  FaChevronRight,
  FaTimes,
  FaFileAlt,
  FaBars,
  FaArrowRight,
  FaGraduationCap,
  FaSearch,
  FaChartBar,
} from "react-icons/fa";

/* =========================================================
   SLIDER DATA
========================================================= */

const SLIDES = [
  {
    id: 1,
    image: slider1,
    alt: "School campus view 1",
    caption: "Empowering Education",
    subtitle: "Building a stronger foundation for every learner",
  },
  {
    id: 2,
    image: slider2,
    alt: "School campus view 2",
    caption: "Building Future Leaders",
    subtitle: "Creating opportunities through quality education",
  },
  {
    id: 3,
    image: slider3,
    alt: "School campus view 3",
    caption: "Excellence in Learning",
    subtitle: "Supporting schools, teachers and students",
  },
  {
    id: 4,
    image: slider4,
    alt: "School campus view 4",
    caption: "Together We Grow",
    subtitle: "Transparent information for a better education system",
  },
];

/* =========================================================
   REPORT DATA
========================================================= */

const CARDS = [
  {
    id: 1,
    // href: "",
    title: "Sanctioned and Working Status",
    description: "Elementary School",
    category: "Elementary",
    icon: FaSchool,
  },
  {
    id: 2,
    // href: "",
    title: "Sanctioned and Working Status",
    description: "Secondary School",
    category: "Secondary",
    icon: FaChalkboardTeacher,
  },
  {
    id: 3,
    // href: "",
    title: "Non Teaching Sanctioned",
    description: "Working Status (School)",
    category: "Non Teaching",
    icon: FaUsers,
  },
];

/* =========================================================
   MAIN NAVIGATION
========================================================= */

const MAIN_NAV_LINKS = [
  {
    // href: "",
    label: "Search Schools",
    icon: FaSearch,
  },
  {
    // href: "",
    label: "Search Schemes",
    icon: FaFileAlt,
  },
  {
    // href: "",
    label: "Prayas",
    icon: FaGraduationCap,
  },
  {
    // href: "",
    label: "NAS Question Bank",
    icon: FaFileAlt,
  },
  {
    // href: "",
    label: "Board Exam Question Bank",
    icon: FaFileAlt,
  },
  {
    // href: "",
    label: "Suggestions from citizen",
    icon: FaUsers,
  },
];

const REPORT_LINKS = [
  {
    // href: "",
    label: "School",
  },
  {
    // href: "",
    label: "Student",
  },
  {
    // href: "",
    label: "Staff",
  },
];

/* =========================================================
   HERO SLIDER
========================================================= */

const HeroSlider = () => {
  const [current, setCurrent] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  const timerRef = useRef(null);
  const touchStartX = useRef(0);

  const total = SLIDES.length;

  const goTo = useCallback(
    (index) => {
      setCurrent((index + total) % total);
    },
    [total]
  );

  const next = useCallback(() => {
    setCurrent((value) => (value + 1) % total);
  }, [total]);

  const prev = useCallback(() => {
    setCurrent((value) => (value - 1 + total) % total);
  }, [total]);

  useEffect(() => {
    if (isPaused) return;

    timerRef.current = setInterval(next, 5000);

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, [isPaused, next]);

  useEffect(() => {
    const handleKeyboard = (event) => {
      if (event.key === "ArrowLeft") prev();
      if (event.key === "ArrowRight") next();
    };

    window.addEventListener("keydown", handleKeyboard);

    return () => {
      window.removeEventListener("keydown", handleKeyboard);
    };
  }, [next, prev]);

  const handleTouchStart = (event) => {
    touchStartX.current = event.changedTouches[0].screenX;
  };

  const handleTouchEnd = (event) => {
    const touchEndX = event.changedTouches[0].screenX;

    const difference =
      touchStartX.current - touchEndX;

    if (Math.abs(difference) > 50) {
      difference > 0 ? next() : prev();
    }
  };

  return (
    <section
      className="hero_banner slider-section"
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
      aria-roledescription="carousel"
      aria-label="School campus image slider"
    >
      <div className="slider-track">
        {SLIDES.map((slide, index) => (
          <div
            key={slide.id}
            className={`slide ${
              index === current ? "active" : ""
            }`}
            aria-hidden={index !== current}
          >
            <img
              src={slide.image}
              alt={slide.alt}
              loading={index === 0 ? "eager" : "lazy"}
            />

            <div className="slide-overlay">
              <div className="slide-content">
                <span className="slide-eyebrow">
                  EDUCATION PORTAL
                </span>

                <h2 className="slide-caption">
                  {slide.caption}
                </h2>

                <p className="slide-subtitle">
                  {slide.subtitle}
                </p>

                <div className="slide-line" />
              </div>
            </div>
          </div>
        ))}
      </div>

      <button
        type="button"
        className="slider-arrow slider-arrow--prev"
        onClick={prev}
        aria-label="Previous slide"
      >
        <FaChevronLeft />
      </button>

      <button
        type="button"
        className="slider-arrow slider-arrow--next"
        onClick={next}
        aria-label="Next slide"
      >
        <FaChevronRight />
      </button>

      <div
        className="slider-counter"
        aria-live="polite"
      >
        <strong>
          {String(current + 1).padStart(2, "0")}
        </strong>

        <span>/</span>

        <span>
          {String(total).padStart(2, "0")}
        </span>
      </div>

      <div
        className="slider-dots"
        role="tablist"
        aria-label="Slide navigation"
      >
        {SLIDES.map((slide, index) => (
          <button
            key={slide.id}
            type="button"
            role="tab"
            aria-selected={index === current}
            aria-label={`Go to slide ${index + 1}`}
            className={`slider-dot ${
              index === current ? "active" : ""
            }`}
            onClick={() => goTo(index)}
          />
        ))}
      </div>

      <div className="slider-progress">
        <div
          className="slider-progress-bar"
          style={{
            width: `${((current + 1) / total) * 100}%`,
          }}
        />
      </div>
    </section>
  );
};

/* =========================================================
   REPORT CARD
========================================================= */

const ReportCard = ({ card, index }) => {
  const Icon = card.icon;

  return (
    <article
      className="report-card"
      style={{
        "--card-delay": `${index * 100}ms`,
      }}
    >
      <a
        href={card.href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`${card.title} - ${card.description}`}
      >
        <div className="report-card-glow" />

        <div className="report-card-top">
          <div className="report-icon">
            <Icon aria-hidden="true" />
          </div>

          <span className="report-number">
            0{index + 1}
          </span>
        </div>

        <div className="report-content">
          <span className="report-badge">
            <FaFileAlt />
            STAFF REPORT
          </span>

          <h3>{card.title}</h3>

          <p>{card.description}</p>
        </div>

        <div className="report-card-footer">
          <span>View Report</span>

          <span className="report-arrow">
            <FaArrowRight />
          </span>
        </div>
      </a>
    </article>
  );
};

/* =========================================================
   MOBILE NAV
========================================================= */

const MobileNavigation = ({
  mobileNavOpen,
  setMobileNavOpen,
  reportsOpen,
  setReportsOpen,
}) => {
  return (
    <>
   

      <div
        className={`mobile-nav-overlay ${
          mobileNavOpen ? "open" : ""
        }`}
        onClick={() => setMobileNavOpen(false)}
        aria-hidden="true"
      />
    </>
  );
};

/* =========================================================
   MAIN DASHBOARD
========================================================= */

const StaffReportDashboard = () => {
  const [mobileNavOpen, setMobileNavOpen] =
    useState(false);

  const [reportsOpen, setReportsOpen] =
    useState(false);

  useEffect(() => {
    document.body.style.overflow = mobileNavOpen
      ? "hidden"
      : "";

    return () => {
      document.body.style.overflow = "";
    };
  }, [mobileNavOpen]);

  return (
    <div className="staff-report-page">

      {/* MOBILE MENU */}
      <MobileNavigation
        mobileNavOpen={mobileNavOpen}
        setMobileNavOpen={setMobileNavOpen}
        reportsOpen={reportsOpen}
        setReportsOpen={setReportsOpen}
      />

      {/* HERO */}
      <div id="divbanner">
        <HeroSlider />
      </div>

      {/* MAIN */}
      <main className="staff-report-main">
        <div className="staff-container">

          {/* BREADCRUMB */}
          <nav
            className="staff-breadcrumb"
            aria-label="Breadcrumb"
          >
            {/* <a href="">
              <FaHome />
              <span>Citizen Window</span>
            </a>

            <span className="breadcrumb-separator">
              <FaChevronRight />
            </span> */}

            {/* <span className="breadcrumb-current">
              Staff Reports
            </span> */}
          </nav>

          {/* SECTION HEADER */}
          <section className="reports-section">

            <div className="section-heading">

              <div className="heading-icon">
                <FaChalkboardTeacher />
              </div>

              <span className="section-kicker">
                STAFF INFORMATION
              </span>

              <h1>
                Staff Reports
              </h1>

              <div className="heading-divider">
                <span />
                <i />
                <span />
              </div>

              <p>
                Access sanctioned and working staff
                information for schools through the
                education reporting portal.
              </p>

            </div>

            {/* REPORT CARDS */}
            <div
              className="reports-grid"
              id="divsearchdashboard"
            >
              {CARDS.map((card, index) => (
                <ReportCard
                  key={card.id}
                  card={card}
                  index={index}
                />
              ))}
            </div>

          </section>

          {/* INFORMATION STRIP */}
          <section className="information-strip">
            <div className="info-strip-icon">
              <FaFileAlt />
            </div>

            <div className="info-strip-content">
              <strong>
                Staff Information Reports
              </strong>

              <span>
                Select a report above to view detailed
                sanctioned and working staff information.
              </span>
            </div>

            <div className="info-strip-arrow">
              <FaArrowRight />
            </div>
          </section>

        </div>
      </main>

      {/* =====================================================
          MODAL 1
      ===================================================== */}

      <div
        id="getdivdetails"
        className="modal fade school_Information student_enrollment_pop_up sanctionedtabelheading"
        role="dialog"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">

            <div className="modal-header">
              <h6 className="modal-title">
                <span id="lbl_popupTitle" />
              </h6>

              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <FaTimes />
              </button>
            </div>

            <div className="modal-body">
              <div className="modal-table-section">
                <h2 id="lbl_popup_tbltitle1" />

                <div
                  id="here_table1"
                  className="table-responsive searchSchool_form"
                />
              </div>

              <div className="modal-table-section">
                <h2 id="lbl_popup_tbltitle2" />

                <div
                  id="here_table2"
                  className="table-responsive searchSchool_form"
                />
              </div>

              <div className="modal-table-section">
                <h2 id="lbl_popup_tbltitle3" />

                <div
                  id="here_table3"
                  className="table-responsive searchSchool_form"
                />
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="modal-close-btn"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>

          </div>
        </div>
      </div>

      {/* =====================================================
          MODAL 2
      ===================================================== */}

      <div
        id="divdetails"
        className="modal fade school_Information"
        role="dialog"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">

            <div className="modal-header">
              <h6 className="modal-title">
                School Information
              </h6>

              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <FaTimes />
              </button>
            </div>

            <div className="modal-body">

              {/* BASIC INFORMATION */}
              <div className="school_Information_Block">
                <h2>
                  School Basic Information
                </h2>

                <div className="information-grid">

                  <div className="information-label">
                    School Name
                  </div>

                  <div className="information-value full">
                    <span className="lbl_Schoolname" />
                  </div>

                  <div className="information-label">
                    Shaladarpan Code
                  </div>

                  <div className="information-value">
                    <span id="lbl_Pnicid" />
                  </div>

                  <div className="information-label">
                    UDise Code
                  </div>

                  <div className="information-value">
                    <span id="lbl_Pdisecode" />
                  </div>

                  <div className="information-label">
                    District
                  </div>

                  <div className="information-value">
                    <span id="lbl_PDistrict" />
                  </div>

                  <div className="information-label">
                    Block
                  </div>

                  <div className="information-value">
                    <span id="lbl_PBlock" />
                  </div>

                </div>
              </div>

              {/* CONTACT */}
              <div className="school_Information_Block">
                <h2>
                  School Contact Detail
                </h2>

                <div className="information-grid">

                  <div className="information-label">
                    Headmaster or Principal
                  </div>

                  <div className="information-value">
                    <span id="lblP_HM_Name" />
                  </div>

                  <div className="information-label">
                    School Email
                  </div>

                  <div className="information-value">
                    <span id="lblP_HM_Email" />
                  </div>

                  <div className="information-label">
                    Locality
                  </div>

                  <div className="information-value">
                    <span id="lblP_locality" />
                  </div>

                  <div className="information-label">
                    Pincode
                  </div>

                  <div className="information-value">
                    <span id="lblP_pincode" />
                  </div>

                </div>
              </div>

              {/* DETAILED */}
              <div className="school_Information_Block">
                <h2>
                  Detailed School Information
                </h2>

                <div className="information-grid">

                  {[
                    ["Rural / Urban", "lblP_Rural_Urban"],
                    ["School Management", "lblP_SchoolManagement"],
                    ["TSP Area / Non TSP Area", "lblP_TSPArea"],
                    ["Low Class", "lblP_Low_Class"],
                    ["High Class", "lblP_High_Class"],
                    ["PEEO", "lblP_IS_PEEO"],
                    ["Sanskrit", "lblP_Is_Sanskrit"],
                    ["Residential / Hostel School", "lblP_Resi_Hostel"],
                    ["CWSN School", "lblP_isCWSN"],
                    ["Computer Lab", "lblP_isComputerLab"],
                    ["Play Ground", "lblp_isPlayGround"],
                  ].map(([label, id]) => (
                    <React.Fragment key={id}>
                      <div className="information-label">
                        {label}
                      </div>

                      <div className="information-value">
                        <span id={id} />
                      </div>
                    </React.Fragment>
                  ))}

                </div>
              </div>

              {/* STREAM */}
              <div className="school_Information_Block">
                <h2>
                  Stream / Subject
                </h2>

                <div className="table-responsive searchSchool_form">
                  <div id="here_tablecom" />
                </div>
              </div>

            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="modal-close-btn"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>

          </div>
        </div>
      </div>

      {/* LOADER */}
      <div
        id="divLoaderImage"
        className="LoaderImage"
        style={{ display: "none" }}
      >
        <div className="loader-spinner">
          <span />
          <span />
          <span />
        </div>
      </div>

    </div>
  );
};

export default  StaffReportDashboard;

